module.exports = InternalShared('InternalShared/Events/GetAdvancedField');